<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>
  <div class="page-wrapper">
    <div class="content">
      <div class="page-header">
        <div class="add-item d-flex">
          <div class="page-title">
            <h4>Liste des Employés</h4>
            <h6>Gérer vos Employés</h6>
          </div>
        </div>
        <ul class="table-top-head">
          <li>
            <a data-bs-toggle="tooltip" data-bs-placement="top" title="Pdf"
              ><img src="@/assets/img/icons/pdf.svg" alt="img"
            /></a>
          </li>
          <li>
            <a data-bs-toggle="tooltip" data-bs-placement="top" title="Excel"
              ><img src="@/assets/img/icons/excel.svg" alt="img"
            /></a>
          </li>
          <li>
            <a data-bs-toggle="tooltip" data-bs-placement="top" title="Print"
              ><i data-feather="printer" class="feather-printer"></i
            ></a>
          </li>
          <li>
            <a data-bs-toggle="tooltip" data-bs-placement="top" title="Refresh"
              ><i data-feather="rotate-ccw" class="feather-rotate-ccw"></i
            ></a>
          </li>
          <li>
            <a
              ref="collapseHeader"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Collapse"
              @click="toggleCollapse"
            >
              <i data-feather="chevron-up" class="feather-chevron-up"></i>
            </a>
          </li>
        </ul>
        <div class="page-btn">
          <a
            v-can="'employees.create'"
            href="javascript:void(0);"
            class="btn btn-added"
            @click.prevent="openAddEmployeeModal"
            ><vue-feather type="plus-circle" class="me-2"></vue-feather>Ajouter
            un nouveau employé</a
          >
        </div>
      </div>
      <!-- /product list -->
      <div class="card table-list-card">
        <div class="card-body">
          <div class="table-top">
            <div class="search-set">
              <div class="search-input">
                <input type="text" placeholder="Search" class="dark-input" />
                <a href="" class="btn btn-searchset"
                  ><vue-feather
                    type="search"
                    class="feather-search"
                  ></vue-feather
                ></a>
              </div>
            </div>
            <div class="search-path">
              <div class="d-flex align-items-center">
                <a
                  class="btn btn-filter"
                  id="filter_search"
                  v-on:click="filter = !filter"
                  :class="{ setclose: filter }"
                >
                  <vue-feather type="filter" class="filter-icon"></vue-feather>
                  <span
                    ><img src="@/assets/img/icons/closes.svg" alt="img"
                  /></span>
                </a>
              </div>
            </div>
            <div class="form-sort">
              <vue-feather type="sliders" class="info-img"></vue-feather>
              <vue-select
                :options="CustomerDate"
                id="customerdate"
                placeholder="Sort by Date"
              />
            </div>
          </div>
          <!-- /Filter -->
          <div
            class="card"
            :style="{ display: filter ? 'block' : 'none' }"
            id="filter_inputs"
          >
            <div class="card-body pb-0">
              <div class="row">
                <div class="col-lg-3 col-sm-6 col-12">
                  <div class="input-blocks">
                    <i data-feather="user" class="info-img"></i>
                    <vue-select
                      :options="CustomerName"
                      id="customerName"
                      placeholder="Choose Customer Name"
                    />
                  </div>
                </div>
                <div class="col-lg-3 col-sm-6 col-12">
                  <div class="input-blocks">
                    <i data-feather="globe" class="info-img"></i>
                    <vue-select
                      :options="CustomerCountry"
                      id="customercountry"
                      placeholder="Choose Customer Name"
                    />
                  </div>
                </div>
                <div class="col-lg-3 col-sm-6 col-12 ms-auto">
                  <div class="input-blocks">
                    <a class="btn btn-filters ms-auto">
                      <i data-feather="search" class="feather-search"></i>
                      Search
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /Filter -->
          <div class="table-responsive">
            <a-table
              class="table datanew"
              :columns="columns"
              :data-source="data"
            >
              <template #bodyCell="{ column, record }">
                <template v-if="column.key === 'emailVerified'">
                  <div>
                    <span
                      :class="
                        record.emailVerified !== null
                          ? 'badge badge-linesuccess'
                          : 'badge badge-linedanger'
                      "
                      >{{
                        record.emailVerified !== null
                          ? "Verifié"
                          : "Non Verifié"
                      }}</span
                    >
                  </div>
                </template>
                <template v-if="column.key === 'action'">
                  <td class="action-table-data">
                    <div class="edit-delete-action">
                      <!-- <a class="me-2 p-2" href="javascript:void(0);">
                        <i data-feather="eye" class="feather-eye"></i>
                      </a> -->
                      <a
                        v-can="'employees.update'"
                        class="me-2 p-2"
                        href="javascript:void(0);"
                        data-bs-toggle="modal"
                        data-bs-target="#edit-units"
                        @click="openEditModal(record)"
                      >
                        <i data-feather="edit" class="feather-edit"></i>
                      </a>
                      <a
                        v-can="'employees.delete'"
                        class="confirm-text p-2"
                        @click="showConfirmation(record.id)"
                        href="javascript:void(0);"
                      >
                        <i data-feather="trash-2" class="feather-trash-2"></i>
                      </a>
                    </div>
                  </td>
                </template>
              </template>
            </a-table>
          </div>
        </div>
      </div>
      <!-- /product list -->
    </div>
  </div>
  <employee-modal
    @client-added="onClientAdded"
    @client-updated="onClientUpdated"
    :data="selectedClient"
    :remaining-admins="remainingAdmins"
    :remaining-users="remainingUsers"
    :max-users="usageData && usageData.quotas ? usageData.quotas.utilisateurs_inclus : null"
    :max-admins="usageData && usageData.quotas ? usageData.quotas.administrateurs_inclus : null"
  ></employee-modal>
</template>
<script>
import { getEmployeesData, deleteEmployee } from "@/services/emplooyesService";
import { getAbonnementUsage } from "@/services/abonnementService";
import { Modal } from "bootstrap";
import { toast } from "vue3-toastify";
const columns = [
  {
    title: "Réf",
    dataIndex: "ref",
  },
  {
    title: "Nom",
    dataIndex: "name",
  },
  {
    title: "Email",
    dataIndex: "email",
  },
  {
    title: "Role",
    key: "role",
    dataIndex: "role",
  },
  {
    title: "Statut d'email",
    key: "emailVerified",
    dataIndex: "emailVerified",
  },
  {
    title: "Dernière connexion",
    key: "lastLoginAt",
    dataIndex: "lastLoginAt",
  },
  {
    title: "Action",
    key: "action",
    sorter: true,
  },
];
const data = [];
import Swal from "sweetalert2";
export default {
  data() {
    return {
      filter: false,
      CustomerCountry: ["Choose Country", "Inda", "USA"],
      CustomerName: [
        "Choose Customer Name",
        "Benjamin",
        "Ellen",
        "Freda",
        "Kaitlin",
      ],
      CustomerDate: ["Sort by Date", "Newest", "Oldest"],
      data,
      columns,
      selectedClient: {},
      // Abonnement usage
      usageData: null,
      remainingUsers: null,
      remainingAdmins: null,
    };
  },
  methods: {
    async loadAbonnementUsage() {
      try {
        const res = await getAbonnementUsage();
        if (res && res.success !== false) {
          this.usageData = res.data || null;
          const u = this.usageData && this.usageData.usage;
          this.remainingUsers = u ? u.utilisateurs_restants : null;
          this.remainingAdmins = u ? u.administrateurs_restants : null;
        }
      } catch (e) {
        // silent: usage is optional for display/control
      }
    },
    openAddEmployeeModal() {
      // Block if no remaining user slots
      if (this.remainingUsers !== null && this.remainingUsers <= 0) {
        const maxUsers =
          (this.usageData && this.usageData.quotas && this.usageData.quotas.utilisateurs_inclus) ??
          (this.usageData && this.usageData.usage
            ? (this.usageData.usage.utilisateurs_actuels || 0) + (this.usageData.usage.utilisateurs_restants || 0)
            : null);
        const msg = maxUsers
          ? `Limite atteinte: votre abonnement inclut ${maxUsers} utilisateur(s). Supprimez un utilisateur existant ou contactez le support pour changer d’abonnement.`
          : "Limite atteinte: votre abonnement ne permet plus d’ajouter d’utilisateurs. Supprimez un utilisateur existant ou contactez le support pour changer d’abonnement.";
        toast.error(msg);
        return;
      }
      // Open the modal programmatically
      const modalElement = document.getElementById("add-units");
      if (modalElement) {
        const modal = Modal.getInstance(modalElement) || new Modal(modalElement);
        modal.show();
      }
    },
    showConfirmation(id) {
      Swal.fire({
        title: "Es-tu sûr de vouloir supprimer cet Employé ?",
        text: "Cette action est irréversible !",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, supprime-le !",
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-danger ml-1",
        buttonsStyling: false,
      }).then(async (result) => {
        if (result.value) {
          try {
            await deleteEmployee(id);

            this.data = this.data.filter((item) => item.id !== id);
            Swal.fire({
              icon: "success",
              title: "Supprimer!",
              text: "Votre Employé  a été supprimé.",
              confirmButtonClass: "btn btn-success",
            });
          } catch (error) {
            console.error(error);
            toast.error(error.response.data.message);
            toast.error(error.response.data.error);
          }
        }
      });
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      return new Intl.DateTimeFormat("fr-GB", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      }).format(date);
    },
    formatDateTime(dateString) {
      if (!dateString) return "Jamais connecté";
      const locale = localStorage.getItem("app_locale") || "fr";
      const localeMap = { fr: "fr-FR", en: "en-GB", ar: "ar-MA" };
      return new Intl.DateTimeFormat(localeMap[locale] || "fr-FR", {
        dateStyle: "medium",
        timeStyle: "short",
      }).format(new Date(dateString));
    },
    async getClientsData() {
      this.data = [];

      try {
        const data = await getEmployeesData();
        data.filter((m) => m.role?.role !== "Dev").forEach((m) => {
          this.data.push({
            id: m.id,
            ref: "EMP--" + m.id,
            name: m.name,
            email: m.email,
            role: m.role.role,
            role_id: m.role.id,
            emailVerified: m.email_verified_at,
            profile_image: m.profile_image,
            lastLoginAt: this.formatDateTime(m.last_login_at),
            CreatedOn: this.formatDate(m.created_at),
          });
        });
      } catch (error) {
        console.error(error);
        toast.error(error.response.data.message);
        toast.error(error.response.data.error);
      }
    },
    toggleCollapse() {
      const collapseHeader = this.$refs.collapseHeader;

      if (collapseHeader) {
        collapseHeader.classList.toggle("active");
        document.body.classList.toggle("header-collapse");
      }
    },
    onClientAdded(m) {

      this.data.push({
        id: m.id,
        ref: "EMP--" + m.id,
        name: m.name,
        email: m.email,
        role: m.role.role,
        emailVerified: null,
        profile_image: m.profile_image,
        lastLoginAt: this.formatDateTime(m.last_login_at),
        CreatedOn: this.formatDate(m.created_at),
      });

      Swal.fire({
        icon: "success",
        title: "Succès",
        text: "Employé créé avec succès.",
        confirmButtonClass: "btn btn-success",
      });
    },
    onClientUpdated(client) {
      this.data.map((m) => {
        if (m.id == client.id) {
          m.id = client.id;
          m.ref = "EMP--" + client.id;
          m.name = client.name;
          m.email = client.email;
          m.role = client.role.role;
        }
      });

      Swal.fire({
        icon: "success",
        title: "Succès",
        text: "Employé modifié avec succès.",
        confirmButtonClass: "btn btn-success",
      });
    },
    openEditModal(item) {
      this.selectedClient = item;
    },
  },
  mounted() {
    this.getClientsData();
    this.loadAbonnementUsage();
  },
};
</script>
